import { defineStore } from "pinia"
import { getCategoriesApi } from "../api/categoryApi"
import { getCategoriesKidsApi } from "../api/kids/categoryApi"
import { showError } from "../services/alertService"
import { theme } from "@/services/getSiteTheme"

export const useCategoriesStore = defineStore("categoriesStore", {
  state: () => ({
    categories: [],
  }),

  getters: {
    getCategories(store) {
      return store.categories
    },
    getActiveCategories(store) {
      return store.categories.filter((cat) => {
        return !!cat.abstractProducts.length
      })
    },
    getMainCategories(store) {
      return store.categories.filter(
        (category) => category.code !== "TEXTBOOKS" && category.code !== "CLOTHING_FORM",
      )
    },
    getHeaderCategories(store) {
      return store.categories.filter(
        (category) => category.code === "FIRST_NATIONS" || category.code === "SPECIAL_KIDS",
      )
    },
  },

  actions: {
    async loadCategories() {
      try {
        this.categories = theme === "default" ? await getCategoriesApi() : await getCategoriesKidsApi()
      } catch (error) {
        showError(error.message)
      }
    },
  },
})
